import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { colors } from '../../styles/vars/colors.style'
import { easings } from '../../styles/vars/easings.style'
import { font } from '../../styles/vars/font.style'
import { mq } from '../../styles/vars/media-queries.style'
import { TextBody } from '../../styles/vars/textStyles.style'
import { ButtonMain } from '../Button/index.style'
import { PageTransitionLinkMain } from '../PageTransitionLink/index.style'

const yScale = 1.1

export const WayToBookCardMain = styled.div`
  background-color: ${colors.dark};

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  ${clamp('padding-top', 24, 48)}
  color: ${colors.light};
  text-align: center;

  ${PageTransitionLinkMain} {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 4;
  }
`

export const WayToBookCardBG = styled.div`
  background-image: url(${props => props.bg});
  background-position: 50% 50%;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  aspect-ratio: 490 / 390;
  width: 100%;
  transform-origin: top;

  ${mq.desk} {
    z-index: 1;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background-color: ${colors.dark};
    opacity: 0.3;
    z-index: 3;
    transition: opacity 0.6s ${easings.in.quart};
  }
`

export const WayToBookCardHeader = styled.div`
  margin-left: auto;
  margin-right: auto;
  ${clamp('padding-right', 10, 22)}
  ${clamp('padding-left', 10, 22)}
  position: relative;
  will-change: transform;
  width: 100%;
  z-index: 4;

  ${mq.deskL} {
    min-width: 29.4rem;
  }
`

export const WayToBookCardItalicTitle = styled.h2`
  margin-left: auto;
  margin-right: auto;
  font-size: 2.8rem;
  font-family: ${font.headingAlt.family};
  font-weight: ${font.headingAlt.weight.light};
  line-height: 1;
  -webkit-font-smoothing: auto;
`

export const WayToBookCardNormalTitle = styled.h2`
  margin-left: auto;
  margin-right: auto;
  font-size: 3.2rem;
  font-family: ${font.heading.family};
  font-weight: 400;
  text-transform: uppercase;
  line-height: 1;
  max-width: 16ch;
  -webkit-font-smoothing: auto;
`

export const WayToBookCardFooter = styled.div`
  ${clamp('padding-bottom', 20, 30)}
  ${clamp('padding-top', 24, 33)}
  ${clamp('padding-left', 15, 47)}
  ${clamp('padding-right', 15, 47)}
  position: relative;
  width: 100%;
  margin-top: auto;
  will-change: transform;
  z-index: 4;
  background-color: ${colors.dark};

  ${TextBody} {
    margin: auto;
    font-size: 1.6rem;
  }
`

export const WayToBookCardWrapper = styled.a`
  border-radius: 0.6rem;
  overflow: hidden;
  filter: drop-shadow(0px 20px 30px rgba(0, 0, 0, 0.2));
  display: block;
  height: 49rem;

  ${ButtonMain} {
    color: ${colors.light};

    ${mq.tabletL} {
      min-width: 23.8rem;
    }
  }

  ${mq.deskMax} {
    ${props => (!props.last ? clamp('margin-right', 12, 24) : '')};
  }

  ${mq.desk} {
    height: 62rem;
    flex: ${props => (props.transitioning ? 1.1 : 1)};
    transform: ${props =>
      props.transitioning ? `scaleY(${yScale})` : undefined};
    transition: flex 0.5s ${easings.inOut.quart},
      transform 0.5s ${easings.inOut.quart};

    ${WayToBookCardBG},
    ${WayToBookCardHeader},
    ${WayToBookCardFooter},
    ${TextBody} {
      transform: ${props =>
        props.transitioning ? `scaleY(${2 - yScale})` : undefined};
      transition: transform 0.5s ${easings.inOut.quart};
    }

    :hover {
      flex: 1.2;
      transform: scaleY(${yScale});

      ${WayToBookCardBG},
      ${WayToBookCardHeader},
      ${WayToBookCardFooter} {
        transform: scaleY(${2 - yScale});
      }
    }

    & + & {
      ${clamp('margin-left', 12, 24)}
    }
  }
`
